import {
  AccordionContentT1,
  AccordionHeaderSetupT1,
  AccordionT1,
} from "Components/Common/Accordion/AccordionT1";

import React from "react";

import { Fragment } from "react";
import FreightDetails from "./FreightDetails";
import { WrapperT1 } from "Components/Common/Wrapper/index";
import FreightDetailsT1 from "./FreightDetailsT1";
import FreightDetailsT2 from "./FreightDetailsT2";
import FreightDetailsT3 from "./FreightDetailsT3";
import FreightDetailsT4 from "./FreightDetailsT4";
import Message from "Components/Common/Message/Message";

const ViewDetailsAccordion = (props) => {
  const {
    isAccordionOpen,
    toggleAccordionOpenClose,
    viewDetailsRoadFreight,
    freightDays,
    avgFreight,
    handleOnChangeAvgFreight,
    vehicleDetails,
    vehicleType,
    handleOnChangeVehicleType,
    viewDetailsRailFreightBcn,
    wagonTypes,
    wagonType,
    handleOnChangeWagonType,
    railRakeList,
    railRake,
    handleOnChangeRailRake,
    handleOnClickForVehicleName,
    handleOnClickRFRPreviousPage,
    handleOnClickRFRNextPage,
    handleOnClickRAFRPreviousPage,
    handleOnClickRAFRNextPage
  } = props;

  return (
    <Fragment>
      <AccordionT1
        style={{
          boxShadow: "0px 0px 10px 0px rgba(82, 138, 234, 0.32)",
          border: "0px",
        }}
      >
        <AccordionHeaderSetupT1
          accordionHeaderSetupBgcolor={"#528AEA"}
          title={"View Details"}
          titleColor={"#FFFFFF"}
          isOpenState={isAccordionOpen}
          action={toggleAccordionOpenClose}
        />

        {isAccordionOpen && (
          <AccordionContentT1 isOpenState={isAccordionOpen}>
            {/* {viewDetailsRoadFreight.length ===0 && <Message />} */}
            {
              <WrapperT1>
                <FreightDetails
                  viewDetailsRoadFreight={viewDetailsRoadFreight}
                  // freightDays={freightDays}
                  // avgFreight={avgFreight}
                  // handleOnChangeAvgFreight={handleOnChangeAvgFreight}
                  // vehicleDetails={vehicleDetails}
                  // handleOnChangeVehicleType={handleOnChangeVehicleType}
                  // vehicleType={vehicleType}
                  handleOnClickForVehicleName ={handleOnClickForVehicleName}
                  handleOnClickRFRNextPage = {handleOnClickRFRNextPage}
                  handleOnClickRFRPreviousPage = {handleOnClickRFRPreviousPage}
                />
              </WrapperT1>
            }
            <WrapperT1>
              <FreightDetailsT1
                viewDetailsRailFreightBcn={viewDetailsRailFreightBcn}
                // wagonTypes={wagonTypes}
                // wagonType={wagonType}
                // handleOnChangeWagonType={handleOnChangeWagonType}
                // railRakeList={railRakeList}
                // railRake={railRake}
                // handleOnChangeRailRake={handleOnChangeRailRake}
                handleOnClickRAFRNextPage = {handleOnClickRAFRNextPage}
                handleOnClickRAFRPreviousPage = {handleOnClickRAFRPreviousPage}
              />
            </WrapperT1>
            {/* <WrapperT1>
              <FreightDetailsT2 />
            </WrapperT1> */}
            {/* <WrapperT1>
              <FreightDetailsT3 />
            </WrapperT1> */}
            {/* <WrapperT1>
              <FreightDetailsT4 />
            </WrapperT1> */}
          </AccordionContentT1>
        )}
      </AccordionT1>
    </Fragment>
  );
};

export default ViewDetailsAccordion;
